import { setThe3dPreviewAvailableAction as setThe3dPreviewAvailableOperation } from 'editor/src/store/editorModules/preview/slice';

export default setThe3dPreviewAvailableOperation;
